export default __webpack_public_path__ + "static/media/ios.5d318f5f.png";